import React, {useCallback, useEffect, useRef, useState} from "react"
import {useHistory, useParams} from 'react-router-dom'
import AuthorizedFunction from '@security/AuthorizedFunction';
import MailIcon from '@material-ui/icons/Mail'
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutline';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn'
import PendenciaService from '@services/PendenciaService'
import TratarPendenciaDialog from '@pages/Pendencia/TratarPendenciaDialog'
import EmailDialog from "@pages/Pendencia/Email/EmailDialog"
import Table from '@base/Table'
import Toast from '@base/Toast'
import {ASC, PAGE, SIZE, TOTAL_ELEMENTS, TOTAL_PAGES, verifyPagingAndSorting,} from '@base/Table/Utils'
import {removePagingAndSorting} from '@helpers/PaginationHelper'
import {ProcessoResolver} from "@helpers/ProcessoHelper"
import RecentActorsOutlinedIcon from "@material-ui/icons/RecentActorsOutlined";
import TextureOutlinedIcon from "@material-ui/icons/TextureOutlined";
import MarkunreadMailboxOutlinedIcon from '@material-ui/icons/MarkunreadMailboxOutlined';

export const PendenciaTableView = (props) => {
  const history = useHistory();
  const processo = ProcessoResolver(useParams().processo);

  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(PAGE);
  const [size, setSize] = useState(props.size ? props.size : SIZE);

  const [defaultOrderBy,] = useState('id');
  const [sort, setSort] = useState([{orderBy: defaultOrderBy, order: ASC}])
  const [totalElements, setTotalElements] = useState(TOTAL_ELEMENTS);
  const [totalPages, setTotalPages] = useState(TOTAL_PAGES);
  const [list, setList] = useState([]);

  const [pendenciaSelecionada, setPendenciaSelecionada] = useState("");
  const [openDialogTratamento, setOpenDialogTratamento] = useState(false);
  const [pendenciaSoLeitura, ] = useState(false);

  const [openDialogEmail, setOpenDialogEmail] = useState(false);

  const toastRef = useRef(null);

  let columns = [
    {label: '', name: 'id', func: null, key: false, item: 'checkbox'},
    {label: 'ID', name: 'id', func: null, key: true}];

  if (!props.ocultaNomeEscola)
    columns = [...columns, {
      label: 'Escola',
      name: 'codigoInep',
      func: (c, l) => (l.codigoInep ? l.codigoInep : "") + " " + (l.escola ? l.escola : ""),
      key: false,
      ordering: false
    }];

  if (!props.ocultaObjetoPostal)
    columns = [...columns, {label: 'Objeto Postal', name: 'numeroObjetoPostal', key: false, ordering: false}];

  columns = [
    ...columns,
    {label: 'Pendência', name: 'tipoPendencia', func: null, key: false},
    {label: 'Data de Criação', name: 'dataCriacao', func: null, key: false},
    {label: 'Status', name: 'ultimoStatus', func: null, key: false},

  ]

  columns = [
    ...columns,
    {label: 'Responsável', name: 'responsavel', func: (c, l) => c, key: false, ordering: false},
    {label: 'Data de Solução', name: 'dataResolucao', filter: 'ultimoStatus.data', func: null, key: false},
    {label: 'Caixa', name: 'caixa', filter: 'objetoPostal.caixa.codigo', func: null, key: false}

  ];

  const handleVerEmail = (id) => {
    setPendenciaSelecionada(id);
    setOpenDialogEmail(true);
  }
  const handleAcessarCartoesIlegiveis = (id, obj) => {
    history.push(`/${processo.id}/cartoes/duplicados?objetosPostais=${obj.numeroObjetoPostal}`);
  }

  const handleAcessarCartoesDuplicados = (id, obj) => {

    history.push(`/${processo.id}/cartoes/duplicados?objetosPostais=${obj.numeroObjetoPostal}`, '_blank', 'noopener,noreferrer');

  }

  const handleAcessarObjetoPostal = (id, obj) => {
    // history.push(`/${processo.id}/objetosPostais/${obj.numeroObjetoPostal}`);
    window.open(`${process.env.REACT_APP_PUBLIC_URL}/${processo.id}/objetosPostais/${obj.numeroObjetoPostal}`, '_blank').focus();
  }

  const handlePage = page => {
    setPage(page);
    props.setFiltroAtivo(true);
  };
  const handleRowsPerPage = (size, page) => {
    setPage(page);
    setSize(size);
    props.setFiltroAtivo(true);
  };
  const verifyOrderBy = (orderBy) => orderBy === 'dataResolucao' ? 'ultimoStatus.data' :
    orderBy === 'caixa' ? 'objetoPostal.caixa.codigo' : orderBy;

  const handleSort = (orderBy, order) => {
    if (sort.find(s => s.orderBy === verifyOrderBy(orderBy))) {
      let newSort = sort.filter(s => s.orderBy !== verifyOrderBy(orderBy));
      newSort.splice(sort.indexOf(sort.find(s => s.orderBy === verifyOrderBy(orderBy))), 0, {
        orderBy: verifyOrderBy(orderBy),
        order: order
      })
      setSort([...newSort]);
    } else {
      setSort([...sort.filter(s => s.orderBy !== verifyOrderBy(orderBy)), {
        orderBy: verifyOrderBy(orderBy),
        order: order
      }]);
    }
    props.setFiltroAtivo(true);
  }

  const handleClearSort = (orderBy) => {
    props.setFiltroAtivo(true);
    orderBy ? setSort([...sort.filter(s => s.orderBy !== verifyOrderBy(orderBy))]) : setSort([{
      orderBy: defaultOrderBy,
      order: ASC
    }])
  };

  const handleTotalPages = () => totalPages;
  const handleTotalElements = () => totalElements;

  const handleTratarPendencia = (id) => {
    setPendenciaSelecionada(id);
    setOpenDialogTratamento(true);
  }

  const handleDeletarPendencia = (id) => {

    PendenciaService.excluir(processo.id, id)
      .then(resultado => {
        setList(list.filter(obj => obj.id !== id));
      }).catch(error => console.log(error));

  }

  let actions = [
    {
      name: () => "Tratar Pendência",
      func: handleTratarPendencia,
      icon: <AssignmentTurnedInIcon/>,
      disabled: () => false,
      collapse: true
    },
    {
      name: () => "Ver Email Enviado",
      func: handleVerEmail,
      icon: <MailIcon/>,
      disabled: (id, object) => !object.seEnviaEmail,
      collapse: true
    },
    {
      name: () => "Ver Cartões Duplicados",
      func: handleAcessarCartoesDuplicados,
      icon: <RecentActorsOutlinedIcon/>,
      disabled: (id, object) => object.tipoPendenciaId !== 16,
      collapse: true
    },
    {
      name: () => "Ver Cartões Ilegíveis",
      func: handleAcessarCartoesIlegiveis,
      icon: <TextureOutlinedIcon/>,
      disabled: (id, object) => object.tipoPendenciaId !== 5,
      collapse: true
    }

  ];

  if (!props.ocultaObjetoPostal) {
    actions = [
      ...actions,
      {
        name: () => "Acessar Objeto Postal",
        func: handleAcessarObjetoPostal,
        icon: <MarkunreadMailboxOutlinedIcon/>,
        disabled: (id, object) => !object.numeroObjetoPostal,
        collapse: true
      }
    ];
  }

  if (AuthorizedFunction(["__processo.usuario.administrador"])) {
    actions = [
      ...actions,
      {
        name: () => "Deletar Pendência",
        func: handleDeletarPendencia,
        icon: <DeleteOutlinedIcon/>,
        disabled: (id, object) => object.ultimoStatus !== "Pendente",
        collapse: true
      }
    ];
  }

  const carregarDados = useCallback(() => {

    setLoading(true);

    const f = verifyPagingAndSorting(removePagingAndSorting(props.filtros), page, size, sort, props.filtroAtivo);

    PendenciaService.filtrar(processo.id, f).then(resultado => {
      let {content, number, size, totalElements, totalPages} = resultado.data;
      content = content.map(data => {

        return {
          "id": data.id,
          "escola": data.escola && data.escola.nome,
          "codigoInep": data.escola && data.escola.codigoInep,
          "numeroObjetoPostal": data.numeroObjetoPostal,
          "tipoPendencia": data.tipoPendencia.descricao,
          "tipoPendenciaId": data.tipoPendencia.id,
          "seEnviaEmail": data.tipoPendencia.configuracaoEnvioEmail.seEnviaEmail,
          "ultimoStatus": data.ultimoStatus.descricao ?? "--",
          "dataCriacao": data.dataCriacao,
          "dataResolucao": data.dataResolucao ?? "--",
          "usuarioResponsavelUltimoStatus": data.usuarioResponsavelUltimoStatus,
          "responsavel": data.responsavel,
          "caixa": data.caixa ?? "--"

        }
      });

      setList(content);
      setPage(number);
      setSize(size);
      setTotalElements(totalElements);
      setTotalPages(totalPages);
      setLoading(false);

    }).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Realizar os Filtros!"));
  }, [props.filtros, props.filtroAtivo, size, page, sort, processo]);

  useEffect(() => carregarDados(), [carregarDados]);

  return (
    <>
      <Toast ref={toastRef}/>

      <Table
        columns={columns}
        tableData={list}
        actions={actions}
        page={page}
        handlePage={handlePage}
        handleTotalPages={handleTotalPages}
        handleTotalElements={handleTotalElements}
        rowsPerPage={size}
        handleRowsPerPage={handleRowsPerPage}
        sort={sort}
        handleSort={handleSort}
        handleClearSort={handleClearSort}
        loading={loading}
        handleChecks={props.handleMarcarPendencia}
      />

      {openDialogTratamento &&
        <TratarPendenciaDialog
          id={pendenciaSelecionada}
          open={openDialogTratamento}
          readonly={pendenciaSoLeitura}
          handleSave={() => carregarDados()}
          handleClose={() => setOpenDialogTratamento(false)}
        />
      }
      
      {openDialogEmail &&
        <EmailDialog
          id={pendenciaSelecionada}
          open={openDialogEmail}
          handleClose={() => setOpenDialogEmail(false)}
        />
      }
    </>
  );
}

export default PendenciaTableView;
